module.exports = __webpack_public_path__ + "static/media/financial-statements.9187cd05.svg";